import './Header.scss'

export default function Header() {
    return (
        <div className='header-wrapper'>
            <div className='p-5 text-center bg-image' style={{backgroundImage: "url('/img/header/marcosyclari-10.jpeg')"}}>
                <div className='mask m-3'>
                <div className='d-flex justify-content-center align-items-center h-100'>
                    <div className='text-white'>
                    <h1 className='mb-3'>Marcos y Clari</h1>
                    <h4 className='mb-3'>Lista de regalos</h4>
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}